import { supabase } from '../config/supabase';
import { getNetlifyFunctionUrl } from '../config/netlify';

export const roleManagementService = {
  async listUsers() {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        throw new Error('No active session');
      }

      const response = await fetch(getNetlifyFunctionUrl('manage-user-roles'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session.access_token}`
        },
        body: JSON.stringify({ operation: 'listUsers' })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to list users');
      }

      const data = await response.json();
      return { users: data.users, error: null };
    } catch (error) {
      console.error('Error listing users:', error);
      return { users: null, error: error.message };
    }
  },

  async getUserRole(userId) {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        throw new Error('No active session');
      }

      const response = await fetch(getNetlifyFunctionUrl('manage-user-roles'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session.access_token}`
        },
        body: JSON.stringify({ operation: 'getUserRole', userId })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to get user role');
      }

      const data = await response.json();
      return { role: data.role, error: null };
    } catch (error) {
      console.error('Error getting user role:', error);
      return { role: null, error: error.message };
    }
  },

  async updateUserRole(userId, role) {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        throw new Error('No active session');
      }

      const response = await fetch(getNetlifyFunctionUrl('manage-user-roles'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session.access_token}`
        },
        body: JSON.stringify({ operation: 'updateUserRole', userId, role })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to update user role');
      }

      const data = await response.json();
      
      // If updating current user's role, refresh the session to get new token with updated role
      const { data: { user } } = await supabase.auth.getUser();
      if (user && user.id === userId) {
        await supabase.auth.refreshSession();
      }
      
      return { success: data.success, error: null };
    } catch (error) {
      console.error('Error updating user role:', error);
      return { success: false, error: error.message };
    }
  }
};
